/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Choices/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Choices({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Content/Unstarted/Content/Choices",
  onChange
  
}) {
let monitoringQuickstartsValueData = fromData.useDataFormat({ viewPath,
context: 'monitoring',
path: 'quickstarts',
format: fromHelpers.getList,
})
let selectedQuickstartIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'quickstart_id',
})
let selectedQuickstartIdChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'quickstart_id',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 maxWidth={250}
 data="monitoring.quickstarts"
 format="./helpers.js getList"
 from={monitoringQuickstartsValueData}
 data="selected.quickstart_id"
 onChange={selectedQuickstartIdChangeData}
 value={selectedQuickstartIdValueData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Choose a quickstart:"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}